
// TODO change back once all components are migrated to .vue files?
import { createApp } from 'vue'
//import { createApp } from 'vue/dist/vue.esm-bundler';

import VueGtag from "vue-gtag";
// import { pageview } from 'vue-gtag'

import { createRouter, createWebHistory } from 'vue-router'
import App from '@/App.vue'
import Collection from '@/views/Collection.vue'
import ArtistPage from '@/views/ArtistPage.vue'
import SearchPage from '@/views/SearchPage.vue'
import FavoritesPage from '@/views/FavoritesPage.vue'
import EventsPage from '@/views/EventsPage.vue'
import HomePage from '@/views/HomePage.vue'
import ContactPage from '@/views/ContactPage.vue'

//const Artist = { template: '<div>Artists</div>' }
const NotFound = { template: '<div>404 - NotFound</div>' }

const app = createApp(App)

const routes = [
    { path: '/', component: HomePage },
    {
        path: '/artists/:artistSlug',
        name: 'artists',
        component: ArtistPage,
        props: true,
        children: [
            { path: ':selectedArtworkSlug', name: "artists/artwork", component: ArtistPage },
        ]
    },
    { path: '/collection', component: Collection },
    { path: '/search', name: 'search', component: SearchPage,
      props: route => {
          return {initialSearch: {
            sortBy: route.query.sortBy,
            keyword: route.query.keyword,
          }};
      }
    },
    { path: '/events', component: EventsPage },
    { path: '/favorites', name: 'favorites', component: FavoritesPage },
    { path: '/contact', name: 'contact', component: ContactPage },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (from.matched[0] && to.matched[0]) {
            const sameComponent = from.matched[0].components.default == to.matched[0].components.default;
            if (!sameComponent) {
                return {
                    top: 0,
                    //behavior: 'smooth',
                }
            }
            //console.log({to, from}, from.matched[0].components.default == to.matched[0].components.default);
        }
    }
})

// router.afterEach(async (to) => {
//     await nextTick()
//     await new Promise(resolve => setTimeout(resolve, 100));

//     // pageview({
//     //     page_path: to.fullPath,
//     //     page_title: document.title
//     // })
//     console.log({to: to.fullPath, title: document.title})
// })

app.use(router)

app.use(VueGtag, {
    config: { id: "G-SC3P0280RE" }
})

app.mount('#app')
